import { globalRoot } from "../../../utils/defaultValues";
import IntlMessages from "../../../utils/IntlMessages";
import MaintainenceInspectionHome from './MaintainenceInspectionHome';
import MISiteOverview from './MISiteOverview';
import MIProtocolView from './MIProtocolsView';

const MaintainenceInspectionRouteConfig = {
  routes: [
    {
      id: "maintainence-inspection",
      path: `${globalRoot}/maintainence-inspection`,
      exact: false,
      showBreadCrumbs: true,
      name: <IntlMessages id={"menu.maintainence-and-inspection"} />,
      element: <MaintainenceInspectionHome />,
      isParent: true,
      children: [
      ],
    },
    {
      path: `${globalRoot}/maintainence-inspection/site-overview/:siteId`,
      element: <MISiteOverview />,
      id: "maintainence-inspection-site",
      parentPath: `${globalRoot}/maintainence-inspection`,
      name: <IntlMessages id={"mi.site-overview"} />,
      showBreadCrumbs: true,
    },
    {
      path: `${globalRoot}/maintainence-inspection/site-overview/:siteId/protocols`,
      element: <MIProtocolView />,
      id: "maintainence-inspection-protocols",
      parentPath: `${globalRoot}/maintainence-inspection/site-overview/:siteId`,
      name: < IntlMessages id={"mi.protocols"} />,
      showBreadCrumbs: true,
    }
  ],
};

export default MaintainenceInspectionRouteConfig;
